export function getDateStringYearsInPast(x: number) {
  const date = new Date()
  date.setFullYear(date.getFullYear() - x)
  return date.toISOString().split('T')[0]
}
